











import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import Question from '@/apps/open/components/Question'
import AddOrRemove from '@/apps/open/components/AddOrRemove'
import { ElForm } from 'element-ui/types/form'

@Component({
  componentName: 'EditDomainWhitelistDialogBody',
  components: {
    Button,
    Question,
    AddOrRemove
  }
})
export default class EditDomainWhitelistDialogBody extends Vue {
  @Prop()
  domainList!: string[]

  @Prop()
  submitCount!: number

  @Prop({
    default: false
  })
  submitting?: boolean

  @Prop()
  appId?: string

  @Prop()
  onCancel!: Function

  @Prop()
  submit!: Function

  $refs!: {
    form: ElForm
  }

  get disabledSubmit () {
    return this.form.domainList.some(i => i === '')
  }

  form = {
    domainList: this.domainList
  }

  rules = [
    { required: true, message: '请输入域名或IP' }
  ]

  addDomain () {
    this.form.domainList.push('')
  }

  removeDomain (index: number) {
    this.form.domainList.splice(index, 1)
  }

  onOk () {
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.submit(this.form.domainList)
      }
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
  }
}
